import { DomHandler } from 'primevue/utils';
import {getCurrentInstance} from "vue";
import {createFeatureFlagConfigurationService} from "@/services/featureFlagService";

export function getBrandIds(filters) {
    const ids: number[] = [];
    if (filters.scopes.scopeIt)
        ids.push(1);
    if (filters.scopes.scopeFinance)
        ids.push(2);
    return ids;
}

function convertUTCDateToLocalDateInternal(date) {
    const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();
    newDate.setHours(hours - offset);
    return newDate;
}

export const formatUtcDate = (date, formatOptions ) => {
    const dateTimeFormat = new Intl.DateTimeFormat(undefined, (formatOptions || { dateStyle: 'medium', timeStyle: 'short' }) as any);
    date = convertUTCDateToLocalDateInternal(new Date(date));
    return dateTimeFormat.format(date);
}

export const getFeatureFlag = async (key) => {
    const app = getCurrentInstance();
    const service = await createFeatureFlagConfigurationService(app);
    const result = await service.get();
    return result.data[key];
};

export const getFeatureFlagWithApp = async (app, key) => {
    const service = await createFeatureFlagConfigurationService(app);
    const result = await service.get();
    return result.data[key];
};

export function convertUTCDateToLocalDate(dateString) {
    return convertUTCDateToLocalDateInternal(new Date(dateString));
}

export function convertLocalDateToUTC(date) {
     return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}

declare global {
    interface Window { dataLayer: any[]; }
}

export const trackEvent = (eventName, params?) => {
    if(!window.dataLayer)
        window.dataLayer = [];
    const event = { event: eventName, ...params };
    window.dataLayer.push(event);
}


export const fixAutoCompleteOverlayPositioning = (autocomplete) => {
    const input = autocomplete.$refs.input;
    input.setAttribute("autocomplete", "none");

    autocomplete.alignOverlay = () => {
        const overlay = autocomplete.overlay;
        const targetOffset = input.getBoundingClientRect();
        const targetOuterHeight = input.offsetHeight;
        const viewport = DomHandler.getViewport();
        const top = targetOuterHeight + targetOffset.top;// + windowScrollTop;

        overlay.style.position = 'fixed';
        overlay.style.top = top + 'px';
        overlay.style.left = targetOffset.left + 'px';
        overlay.style.maxHeight = (viewport.height - top) + "px";
    };
}

export const convertSalutationForDatabase = (salutation) => {
    if (salutation === "Mr.")
        return "Herr";
    if (salutation === "Ms.")
        return "Frau";

    return salutation;
}

export function isMobile() {
    return screen.width < 440;
}

export const prefixBaseUrlOneApi = "/api/v2";
export const getBaseUrlOneApi = () => {
    let baseUrl = window.location.origin;
    baseUrl = baseUrl.replace("-admin.", "-api.");
    baseUrl = baseUrl.replace("-site.", "-api.");
    baseUrl = baseUrl.replace("-candidates.", "-api.");
    return baseUrl;
}
